import {
  IconButton,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { textStyle } from "src/styles/textstyle";
import theme from "src/styles/mainstyle";
import { useMediaQuery, useTheme } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FindHomesSearchBox from "src/components/search/FindHomesSearchBox";

type FindHomesModalProps = {
  open: boolean;
  onClose: () => void;
};

const FindHomesModal = ({ open, onClose }: FindHomesModalProps) => {
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={open} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: !isDesktop ? "min(42rem, 94vw)" : "95vw",
            maxHeight: "90vh",
            overflow: "hidden",
            bgcolor: "background.paper",
            borderRadius: 4,
            border: "1px solid #e2e8f0",
            boxShadow: "0 16px 46px rgba(15, 23, 42, 0.2)",
          }}
        >
          <Box sx={{ px: { xs: 2.5, sm: 3.5 }, py: { xs: 2, sm: 2.5 }, borderBottom: "1px solid #e2e8f0" }}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
              <Box>
                <Typography variant="h5" sx={{ ...textStyle, fontWeight: 700, color: "#0f172a" }}>
                  Find homes
                </Typography>
                <Typography sx={{ ...textStyle, color: "#64748b", mt: 0.8 }}>
                  Search by destination, travel period, and home size.
                </Typography>
              </Box>
              <IconButton onClick={handleCloseModal} size="small" sx={{ color: "#475569", mt: 0.2 }}>
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Box>

          <FindHomesSearchBox
            mode="modal"
            source="find_homes_modal"
            onCancel={handleCloseModal}
            onSubmitted={handleCloseModal}
          />
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default FindHomesModal;
